const ADJUST_LINK = 'https://moozpro.go.link?adj_t=1o2ioorl&adj_campaign=paid_trafic';

export const storeLinks = {
  googlePlay: ADJUST_LINK,
  microsoftStore: ADJUST_LINK,
  appleStore: ADJUST_LINK,
};

export const appLinks = {
  linux: 'https://moozpro.go.link/?adj_t=1osm1v9y&adj_campaign=paid_trafic&adj_' +
      'redirect=https%3A%2F%2Fmooz.pro%2Fapp%2FMOOZ.deb',
  windows: 'https://moozpro.go.link/?adj_t=1oops7fy&adj_campaign=paid_trafic&adj_' +
      'redirect=https%3A%2F%2Fmooz.pro%2Fapp%2FMOOZ-win.exe',
  android: 'https://moozpro.go.link/?adj_t=1o9e3ccr&adj_campaign=paid_trafic&adj_' +
      'redirect=https%3A%2F%2Fmooz.pro%2Fapp%2Fmooz.apk',
};

export const feedbackLinks = {
  google: 'https://play.google.com/store/apps/details?id=musiconline.school',
  apple: 'https://apps.apple.com/app/id1643103017',
  trustpilot: 'https://www.trustpilot.com/review/mooz.pro',
};

export const DEFAULT_MOOZ_LINK = 'https://mooz.pro/';